import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ChevronLeft } from '../../../assets/icons'
import useIsMobile from '../../../hooks/useIsMobile'
import { BackTitle, Header, DefaultTitle } from './styled'

const BackPageHeader = ({
	onBack,
	title,
	showBack = true,
	hideBackOnMobile = true,
	gap = '12px',
	marginBottom = '0',
	padding = '0',
	className
}) => {
	const isMobile = useIsMobile()
	const shouldShowBack = showBack && typeof onBack === 'function' && (!hideBackOnMobile || !isMobile)

	return (
		<Header className={className} style={{ gap, marginBottom, padding }}>
			
			{(shouldShowBack && onBack) && (
				<BackTitle m={'0'} onClick={onBack}>
					<ChevronLeft size={8} /> Volver
				</BackTitle>
			)}
			{typeof title === 'string' ? <DefaultTitle>{title}</DefaultTitle> : title}
		</Header>
	)
}

BackPageHeader.propTypes = {
	onBack: PropTypes.func,
	title: PropTypes.node.isRequired,
	showBack: PropTypes.bool,
	hideBackOnMobile: PropTypes.bool,
	gap: PropTypes.string,
	marginBottom: PropTypes.string,
	padding: PropTypes.string,
	className: PropTypes.string
}


export default BackPageHeader